<template>
  <div class="mainview">

<!--    <img alt="Vue logo" src="../assets/logo.png">-->
    <div class="mynavbar">
        <NavBar/>
    </div>

    <div class="columns is-gapless">
        <!-- <div class="column mycolumn mycolumn-menu is-narrow"> -->
        <div class="column mystyle-sidemenu is-narrow">
            <SideMenu/>
        </div>
        <!-- <div class="column mycolumn"> -->
        <div class="column">

            <!--<h2>User {{ $route.params.id }}</h2>-->

            <router-view/>

        </div>
    </div>

<!--      <SideMenu/>-->
<!--      <Demo msg="Hello Demo"/>-->
  </div>
</template>

<script>
    import NavBar from '@/components/main/NavBar.vue'
    import SideMenu from '@/components/main/SideMenu.vue'

    export default {
        name: "mainview",
        components: {
            SideMenu,
            NavBar
    }

    }

</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .is-one-fifth {
        background: #118575;
    }
    .mynavbar {
        background: #118575;
    }
    .mycolumn {
        padding-left: 0em;
        padding-right: 0em;
    }
    .mystyle-sidemenu {
        background: #118575;
        padding-left: 0.3em;
        padding-right: 0.3em;
    }
</style>
